import { AngularEditorConfig } from '@kolkov/angular-editor';

export class AppConstants {
    static readonly hmca: string = "hmca";
    static readonly other: string = "other";
    static readonly dealerActualBenefits: string = "Actual Benefits";
    static readonly easternRegion: string = "Eastern Region";
    static readonly westernRegion: string = "Western Region";
    static readonly northernRegion: string = "Northern Region";
    static readonly southernRegion: string = "Southern Region";
    static readonly centralRegion: string = "Central Region";

    static readonly editorConfig: AngularEditorConfig = {
        editable: true,
        spellcheck: true,
        height: 'auto',
        minHeight: '300px',
        maxHeight: 'auto',
        width: 'auto',
        minWidth: '0',
        translate: 'yes',
        enableToolbar: true,
        showToolbar: true,
        placeholder: 'Enter text here...',
        defaultParagraphSeparator: '',
        defaultFontName: '',
        defaultFontSize: '',
        fonts: [
            { class: 'arial', name: 'Arial' },
            { class: 'times-new-roman', name: 'Times New Roman' },
            { class: 'calibri', name: 'Calibri' },
            { class: 'comic-sans-ms', name: 'Comic Sans MS' },
            { class: 'hyunda-sans-head-office', name: 'Hyundai Sans Head Office' },
            { class: 'hyunda-sans-text-office', name: 'Hyundai Sans Text Office' }
        ],
        customClasses: [
            {
                name: 'quote',
                class: 'quote',
            },
            {
                name: 'redText',
                class: 'redText'
            },
            {
                name: 'titleText',
                class: 'titleText',
                tag: 'h1',
            },
        ],
        uploadUrl: 'v1/image',
        uploadWithCredentials: false,
        sanitize: true,
        toolbarPosition: 'top',
        toolbarHiddenButtons: [
            [],
            [
                'customClasses',
                'insertImage',
                'insertVideo',
                'insertHorizontalRule',
                'removeFormat',
            ]
        ]
    };
}

export class ExceptionModel {
    ExceptionTitle: string;
    ExceptionMessage: string;
}

export class AppDetails {
    static readonly title: string = "Vehicle Stocktake";
    static readonly shortTitle: string = "Vehicle Stocktake";
}

export class ApprovalStatusConstants {
    static readonly Approved = "Approved";
    static readonly Rejected = "Rejected";
    static readonly Pending = "In Progress";
    static readonly Submitted = "Submitted";
    static readonly Resubmitted = "Resubmitted";
    static readonly NotSubmitted = "Not Submitted";
    static readonly MoreInfo = "MoreInfo";
    static readonly Authorised = "Authorised";
}

export class RouterConstants {
    static readonly Empty = "";
    static readonly Stocktake = "Stocktake";
    static readonly FBTDeclaration = "FBTDeclaration";

    //static readonly New = "InitiateProcess";
    //static readonly EmailTemplates = "EmailTemplates";
    //static readonly Users = "Users";
    //static readonly LookUps = "Settings";
    //static readonly Review = "Review";
    //static readonly Approve = "Approve";
    static readonly Error = "Error";
    static readonly NoMatch = "**";
}

export class ResendEmailInput {
    EmailAuditID: string;
    FBTID: number;
    To: string;
    CC: string;
    EmailBody: string;
    EmailSubject: string;
    IsEmailEdited: boolean;
}

export class RequestStatus {
    static readonly Total = "";
    static readonly NotSubmitted = "NotSubmitted";
    static readonly Finance = "Finance";
    static readonly MoreInfo = "MoreInfo";
    static readonly Completed = "Completed";
    static readonly EmailFailed = "EmailFailed";
}

export class DefaultValues {
    CurrentFinancialYear: string;
}

export class ProvidedRoles {
    Finance: string = "Finance";
    Admin: string = "Admin";
    User: string = "User";
}

export class UserDetails {
    UserID: string;
    DomainUserID: string;
    Email: string;
    FullName: string;
    Domain: string;
    ManagerID: string;
    DomainManagerID: string;
    UserRole: string;
    IsActive: boolean;
}

export class EmailAuditTemplateData {
    FBTRefNumber: string;
    FBTID: number;
    EmailAuditID: string;
}

//#region Admin Models
export class UserData {
    ID: number;
    DomainUserID: string;
    UserRole: string;
    IsActive: boolean;
}

export class EmailTemplate {
    ID: number;
    EmailName: string;
    EmailSubject: string;
    EmailBody: string;
    IsActive: boolean;
    Action: string;
}

export class Lookup {
    ID: number;
    LookupType: string;
    LookupValue: string;
    Action: string;
}

export class DealerAttachmentDetails {
    FBTReferenceNumber: string;
    AttachmentTypeID: number;
    AttachmentType: string;
    DealerID: string;
    DealerName: string;
}

export class ProcessStatusConstants {
    static readonly Initiated: string = "FBT Process Initiated";
    static readonly Submitted: string = "Submitted";
    static readonly Resubmitted: string = "Resubmitted";
    static readonly MoreInfoRequested: string = "MoreInfo Requested";
    static readonly Completed: string = "FBT Process Completed";
}
//#endregion

export class LoggedInDealerGroups {
    IsDealerSelected: boolean;
    CompanyName: string;
    DealerCode: string;
    DealerTradingName: string;
    DealerFBTReferenceNumber: string;
    DealerGroupReferanceNumber: string;
    IsEditable: boolean;
    To: string;
    CC: string;
}
